export type DashboardConfig = {
  items: DashboardItem[];
};

export enum DashboardItemType {
  Tasks = 'tasks',
  Planning = 'planning',
  Articles = 'articles',
  Journey = 'journey',
  JobSearch = 'searchjobs',
  Jobs = 'jobs',
  Knowledge = 'knowledgechatbot',
}

export type DashboardItem = {
  type: DashboardItemType;
};
